import * as React from 'react'
function SvgViewFilled(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M20 32c7.2 0 12.8-6.2 15.2-9.8 1-1.4 1-3.2 0-4.6C32.8 14.2 27.2 8 20 8c-7.2 0-12.8 6.2-15.2 9.8-1 1.4-1 3.2 0 4.4 2.4 3.6 8 9.8 15.2 9.8zm0-18c3.4 0 6 2.6 6 6s-2.6 6-6 6-6-2.6-6-6 2.6-6 6-6z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgViewFilled
